/* ==========================================================================
   Kaufwerk – Produktempfehlungen
   ========================================================================== */
(function () {
  'use strict';

  const parseHTML = (text) => new DOMParser().parseFromString(text, 'text/html');

  /* ---------- Produktempfehlungen (Product Recommendations API) ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      const load = () => this.load();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.observer.disconnect();
              load();
            }
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      } else {
        load();
      }
    }

    async load() {
      this.dataset.loaded = 'true';
      try {
        const response = await fetch(this.dataset.url);
        const doc = parseHTML(await response.text());
        const fresh = doc.querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim().length) {
          this.innerHTML = fresh.innerHTML;
        } else {
          this.closest('.shopify-section')?.classList.add('is-empty');
          this.hidden = true;
        }
      } catch (error) {
        this.hidden = true;
      }
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

})();
